/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  ApproveFollowRequestMutationRequest,
  ApproveFollowRequestMutationResponse,
  ApproveFollowRequestPathParams,
  ApproveFollowRequest401,
  ApproveFollowRequest403,
  ApproveFollowRequest404,
} from "../types/ApproveFollowRequest.ts"
import {
  approveFollowRequestMutationResponseSchema,
  approveFollowRequestMutationRequestSchema,
} from "../zod/approveFollowRequestSchema.ts"

function getApproveFollowRequestUrl(
  requestId: ApproveFollowRequestPathParams["requestId"],
) {
  const res = {
    method: "PUT",
    url: `/follow-requests/${requestId}/approve` as const,
  }
  return res
}

/**
 * @summary Approve a follow request
 * {@link /follow-requests/:requestId/approve}
 */
export async function approveFollowRequest(
  requestId: ApproveFollowRequestPathParams["requestId"],
  data: ApproveFollowRequestMutationRequest,
  config: Partial<RequestConfig<ApproveFollowRequestMutationRequest>> & {
    client?: typeof fetch
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = approveFollowRequestMutationRequestSchema.parse(data)

  const res = await request<
    ApproveFollowRequestMutationResponse,
    ResponseErrorConfig<
      | ApproveFollowRequest401
      | ApproveFollowRequest403
      | ApproveFollowRequest404
    >,
    ApproveFollowRequestMutationRequest
  >({
    method: "PUT",
    url: getApproveFollowRequestUrl(requestId).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return approveFollowRequestMutationResponseSchema.parse(res.data)
}
